export default __webpack_public_path__ + "static/3_25-95ec1b4d9196fd2bcaee641fd5a287e3.png";